export default "__VITE_ASSET__DzPPE5yk__"